import { render, staticRenderFns } from "./IconMinus.vue?vue&type=template&id=5899eaf2&"
import script from "./IconMinus.vue?vue&type=script&lang=ts&"
export * from "./IconMinus.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports